var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getUri } from '../config/uri';
let newAccess = '';
const cookieCall = (customRefreshUri) => __awaiter(void 0, void 0, void 0, function* () {
    const refreshUri = (customRefreshUri || getUri().replace('/graphql/', '/rest/')) + 'jwt/refresh';
    const response = yield fetch(refreshUri, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (response.status !== 200) {
        throw new Error('User is not authenticated');
    }
    return response.json();
});
const getRefreshToken = ({ manageRedirect, isSilent, refreshUri }) => __awaiter(void 0, void 0, void 0, function* () {
    const storedDate = localStorage.getItem('matchplat_auth_token_expires');
    const now = new Date();
    const expireDate = new Date(storedDate);
    const getToken = () => __awaiter(void 0, void 0, void 0, function* () {
        const { accessToken, expires } = yield cookieCall(refreshUri);
        localStorage.setItem('matchplat_auth_token_expires', expires);
        newAccess = accessToken;
    });
    if (isSilent) {
        yield getToken();
    }
    if (isNaN(now.getTime()) || now.getTime() >= expireDate.getTime() || newAccess === '') {
        try {
            yield getToken();
        }
        catch (err) {
            if (manageRedirect) {
                yield fetch((refreshUri || getUri().replace('/graphql/', '/rest/')) + 'sso-path')
                    .then((res) => res.json())
                    .then((res) => {
                    const redirect = `${res.path}#/?landing=${window.location.href}`;
                    window.location.replace(redirect);
                });
            }
            else {
                throw new Error('User is not authenticated');
            }
        }
    }
    return newAccess;
});
export default getRefreshToken;
